import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Icon as CompassIcon } from "@circleco/compass/components/Icon";
import { Menu } from "@circleco/compass/components/Menu";
import type { MenuOptions } from "@circleco/compass/components/Menu";
import { Tooltip } from "@circleco/compass/components/Tooltip";
import { Link, useRouterState } from "@tanstack/react-router";
import { useState } from "react";

import { t } from "@/i18n-js/instance";

import { isBuildItemActive } from "./buildItemActive";
import {
  DOCK_NAV_ACTIVE_CLASSES,
  DOCK_NAV_ICON_BUTTON_CLASSES,
} from "./constants";
import type { BuildNavItem } from "./types";

interface CircleAIDockBuildMenuProps {
  items: BuildNavItem[];
}

export const CircleAIDockBuildMenu = ({
  items,
}: CircleAIDockBuildMenuProps) => {
  const pathname = useRouterState({ select: s => s.location.pathname });
  const [isOpen, setIsOpen] = useState(false);

  const isRouteActive = items.some(item => isBuildItemActive(item, pathname));

  const options: MenuOptions = [
    {
      label: t("circle_ai_dock.sections.build"),
      items: items.map(item => ({
        label: item.label,
        ...(item.compassIcon ? { icon: item.compassIcon } : {}),
        ...(item.children?.length
          ? {
              submenu: item.children.map(child => ({
                label: child.label,
                renderLink: <Link to={child.to} />,
              })),
            }
          : { renderLink: <Link to={item.path} /> }),
      })),
    },
  ];

  return (
    <Menu
      side="right"
      align="start"
      options={options}
      onOpenChange={setIsOpen}
      trigger={
        <Tooltip content={t("circle_ai_dock.sections.build")} side="right">
          <button
            type="button"
            aria-label={t("circle_ai_dock.sections.build")}
            className={classNames(
              DOCK_NAV_ICON_BUTTON_CLASSES,
              (isOpen || isRouteActive) && DOCK_NAV_ACTIVE_CLASSES,
            )}
          >
            <CompassIcon name="dot-menu" size="md" color="primary" />
          </button>
        </Tooltip>
      }
    />
  );
};
